//src/Components/TopBar/ClientSupportButton.tsx
import { ClientSupportIcon } from 'assets/icons';
import useCreateModal from 'Components/Popups/useCreateModal';
import SubmitTicketForm from 'app/features/tickets/SubmitTicketModal';
import { useAuth } from 'utils/AuthProvider';

const ClientSupportButton = () => {
  const SubmitTicketModal = useCreateModal();
  const { isAdmin } = useAuth();

  if (isAdmin) return <></>;

  return (
    <div className="tooltip-wrapper">
      <div
        id="client-support-btn" // Add id for programmatic clicking
        className="relative cursor-pointer w-8 h-8 shadow mr-2 rounded-full flex justify-center items-center button-wrapper"
        onClick={() => {
          SubmitTicketModal.open();
        }}
      >
        <ClientSupportIcon className="w-6 h-6 text-green" />
      </div>
      <span className="tooltip-text">Submit a ticket</span>

      <SubmitTicketModal.Component>
        <SubmitTicketForm />
      </SubmitTicketModal.Component>
    </div>
  );
};
export default ClientSupportButton;
